import { Router } from './Router';
import { QueryProvider } from './providers/QueryProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import '@/lib/i18n'; // Initialize i18n

function App() {
  return (
    <QueryProvider>
      <ThemeProvider>
        <Router />
      </ThemeProvider>
    </QueryProvider>
  );
}

export default App;
